import { render, staticRenderFns } from "./BaseAutocompleteUser.vue?vue&type=template&id=447466b8"
import script from "./BaseAutocompleteUser.vue?vue&type=script&lang=ts"
export * from "./BaseAutocompleteUser.vue?vue&type=script&lang=ts"
import style0 from "./BaseAutocompleteUser.vue?vue&type=style&index=0&id=447466b8&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports